const StreamAccountModel = Backbone.Model.extend({
  defaults: {
    filter: '',
    type: 'social',
  },

  initialize(options) {
    this.filter = options.filter;
    this.type = options.type;
  },

});

export default StreamAccountModel;
